<template>
  <div>
    <div
      class="border-[1.5px] border-solid border-[#DBDCE0] rounded-[4px] w-full"
    >
      <div class="bg-[#FBFBFB] w-full">
        <p
          class="text-[#000000] text-[12px] leading-[18px] font-medium px-[24px] py-[14px]"
        >
          Manage Inventory
        </p>
        <div class="w-full bg-white flex flex-col justify-start">
          <div
            v-for="(item, index) in menuItems"
            :key="index"
            class="py-[10px] px-[24px] border-b w-full cursor-pointer"
            @click="navigateTo(item.route)"
          >
            <div class="max-w-[500px] w-full flex items-center justify-between">
              <div class="flex gap-[14.5px] items-center">
                <img
                  :src="item.icon"
                  :alt="item.label"
                  class="w-[48px] h-[48px]"
                />
                <p
                  class="text-[#353535] font-medium leading-[19.36px] text-[16px]"
                >
                  {{ item.label }}
                </p>
              </div>
              <div>
                <span class="fa-solid fa-chevron-right cursor-pointer"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuItems: [
        {
          label: "Receive Stock",
          icon: "/assets/icon/recieve.svg",
          route: "/managestocksummary",
        },
        {
          label: "Stock Transfer",
          icon: "/assets/icon/stock.svg",
          route: "/stocktransfer",
        },
        {
          label: "Issue Stock",
          icon: "/assets/icon/recieve.svg",
          route: "/issue-stock",
        },
        {
          label: "Customer Returns",
          icon: "/assets/icon/customer.svg",
          route: "/customer-returns",
        },
        {
          label: "Storage Location",
          icon: "/assets/icon/location.svg",
          route: "/storage-areas",
        },
        {
          label: "Stock Reconciliation",
          icon: "/assets/icon/recon.svg",
          route: "/reconcileorderstostock",
        },
      ],
    };
  },
  methods: {
    navigateTo(route) {
      this.$router.push(route);
    },
  },
};
</script>
